import React from 'react';
import './PricingFormationEntra.css'; 
import CheckIcon from '../../../assets/icons/CheckIcon';
import FighterJetIcon from '../../../assets/icons/FighterJetIcon';
import RocketIcon from '../../../assets/icons/RocketIcon';
import { useTranslation } from 'react-i18next';

const PricingFormationEntra: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="price-section">
      <div className="card-scroll-embed w-embed"></div>
      <div id="Price-Details" className="container-2">
        <section>
          <div className="container-fluid">
            <div className="container-2">
              <div className="row center-columns">
                <div className="col-sm-4">
                  <div className="card-entra card text-center">
                    <div className="pricing_title">
                      <div className="icon-circle">
                        <FighterJetIcon />
                      </div>
                      <h2>{t('formationEntra.pricing.card1.title', 'Formation en distanciel')}</h2>
                    </div>
                    <div className="price">
                      <h4 style={{ marginBottom: 2 }}>
                        6300<sup className="euro">€</sup> <span className="tw-text-[20px]">{t('formationEntra.pricing.taxExcluded', 'HT')}</span>
                      </h4>
                      <h4 style={{ marginTop: 0 }}>
                        <sup>{t('formationEntra.pricing.modules', '4 modules')}</sup>
                      </h4>
                    </div>
                    <div className="option">
                      <ul>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card1.features.1', 'Fomation dispensée en 22 heures')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card1.features.2', 'Formation en visioconférence')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card1.features.3', 'Dispensée par des experts Microsoft')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card1.features.4', 'Connaissances théoriques, démonstrations et mise en application')}
                        </li>
                        <li>
                        <CheckIcon /> {t('formationEntra.pricing.card1.features.5', 'Accès à toutes les ressources de la formation sur la plateforme ITM Academy')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card1.features.6', 'Support technique post-formation')}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="card-entra card text-center">
                    <div className="pricing_title">
                      <div className="icon-circle">
                        <RocketIcon />
                      </div>
                      <h2>{t('formationEntra.pricing.card2.title', 'Formation en présentiel')}</h2>
                    </div>
                    <div className="price">
                      <h4 style={{ marginBottom: 2 }}>
                        6930<sup className="euro">€</sup><span className="tw-text-[20px]">{t('formationEntra.pricing.taxExcluded', 'HT')}</span>
                      </h4>
                      <h4 style={{ marginTop: 0 }}>
                        <sup>{t('formationEntra.pricing.modules', '4 modules')}</sup>
                      </h4>
                    </div>
                    <div className="option">
                      <ul>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card2.features.1', 'Fomation dispensée en 22 heures')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card2.features.2', 'Déplacement sur site')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card2.features.3', 'Dispensée par des experts Microsoft')}
                        </li>
                        <li>
                          <CheckIcon /> {t('formationEntra.pricing.card2.features.4', 'Connaissances théoriques, démonstrations et mise en application')}
                        </li>
                        <li>
                        <CheckIcon /> {t('formationEntra.pricing.card2.features.5', 'Accès à toutes les ressources de la formation sur la plateforme ITM Academy')}
                        </li>
                        <li>
                        <CheckIcon /> {t('formationEntra.pricing.card2.features.6', 'Support technique post-formation')}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PricingFormationEntra;